import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList";
import PencilIcon from "vue-material-design-icons/Pencil";
import notificationMenu from "../vue-notifications/menu_items";
import newsMenu from "../news/menu_items";
import messagingMenu from "../messaging/menu_items";
import DMSMenu from "../vue-dms/menu_items";
import FormMenu from "../vue-forms247/app/menu_items";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Main Menu",
    children: [
      {
        name: "Leave Request",
        children: [
          {
            icon: "view-list",
            title: "List Leave Request",
            to: {
              name: "leave_request.list",
              query: {
                limit: 10,
                filter: "my_leave_requests",
                sort: "created_date",
                order: "desc",
              },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Leave Request",
            to: { name: "leave_request.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Volunteer",
        children: [
          {
            icon: "view-list",
            title: "Weekend Volunteer Sheet",
            to: { name: "volunteer" },
            loggedIn: true,
            pref: "volunteer__enable_weekend_sheet",
          },
        ],
        loggedIn: true,
      },
      ...messagingMenu,
      ...notificationMenu,
      ...DMSMenu,
    ],
  },
  {
    name: "Leave",
    children: [
      {
        name: "Block Out Date",
        children: [
          {
            icon: "view-list",
            title: "List Block Out Date",
            to: {
              name: "block_out_date.list",
              query: { limit: 10, filter: "all" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Block Out Date",
            to: { name: "block_out_date.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Leave Limit",
        children: [
          {
            icon: "view-list",
            title: "List Leave Limit",
            to: {
              name: "leave_limit.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Leave Limit",
            to: { name: "leave_limit.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Employee",
        children: [
          {
            icon: "view-list",
            title: "List Employee",
            to: { name: "employee.list", query: { limit: 10, filter: "all" } },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Employee",
            to: { name: "employee.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Employee Manager",
        children: [
          {
            icon: "view-list",
            title: "List Employee Manager",
            to: {
              name: "employee_manager.list",
              query: { limit: 10, filter: "all" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Employee Manager",
            to: { name: "employee_manager.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
    ],
  },
  {
    name: "News",
    children: [...newsMenu],
  },
  // {
  //   name: "Notifications",
  //   children: [...notificationMenu],
  // },
  // {
  //   name: "Document Management",
  //   children: [...DMSMenu],
  // },
  {
    name: "Forms",
    children: [...FormMenu],
  },
  {
    name: "Admin",
    children: [
      {
        name: "Users & Roles",
        children: [
          {
            icon: "view-list",
            title: "List Users",
            to: {
              name: "user.list",
              query: {
                limit: 25,
                filter: "active",
                sort: "email",
                order: "asc",
              },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Groups",
            to: {
              name: "group.list",
              query: { limit: 25, filter: "all", sort: "name", order: "asc" },
            },
            loggedIn: true,
          },

          /*Uncomment to Enable.{
        icon: 'view-list',
        title: 'List Group Permissions',
        to: {name: 'group_permissions.list', query: {'limit': 25, 'filter': 'all', 'sort':'group', 'order':'asc'}},
        loggedIn: true,
      },*/
        ],
        loggedIn: true,
      },
      {
        name: "Email Message",
        children: [
          {
            icon: "view-list",
            title: "List Email Message",
            to: {
              name: "email_message.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "SMS",
        children: [
          {
            icon: "view-list",
            title: "List SMS",
            to: {
              name: "sms.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Manage",
        children: [
          {
            icon: "view-list",
            title: "List Leave Type",
            to: {
              name: "code_leave_type.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Depot",
            to: {
              name: "code_depot.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Employee Type",
            to: {
              name: "code_employee_type.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Employee Category",
            to: {
              name: "code_employee_category.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Doc Notification Rules",
            to: {
              name: "document_notification_rule.list",
              query: { limit: 25, filter: "active", sort: "id" },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Volunteer",
        children: [
          {
            icon: "view-list",
            title: "Manage Shifts",
            to: {
              name: "volunteer_shift.list",
              query: { limit: 25, filter: "active", sort: "shift_id" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Shift",
            to: { name: "volunteer_shift.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Generate Code",
        children: [
          {
            icon: "pencil",
            title: "New QR Code",
            to: { name: "qr.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
    ],
  },
];
